// TODO: the id should be generated by balancing, but we cannot right now cause the project is being halted.
var Replacements = new Map([["upgradableStarSphere", function (name, level) { return "starSphere" + level + "1"; }]]);
export var GetArtAssetId = function (name, level) {
    if (!Replacements.has(name)) {
        return "" + name + level;
    }
    return Replacements.get(name)(name, level);
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/GetArtAssetId.ts
// module id = 2196
// module chunks = 3